<div *ngIf="resizing" class="resizing-bg"></div>
<div
  *ngIf="!isTry"
  (mousedown)="isResizing()"
  [ngClass]="showDraggable ? 'block' : 'hidden'"
  class="draggable-container container"
  cdkDrag
  cdkDragBoundary=".activities__wrapper"
  (cdkDragEnded)="onDragDropped($event)">
  <div class="bg-gray" cdkDragHandle>
    <div class="flex justify-between items-center">
      <div class="flex items-center pointer fullwidth">
        <svg-icon key="drag" size="xxl" class="items-center"></svg-icon>
        <div class="mx-6 h2-spacing">{{ title }}</div>
      </div>
      <div class="flex pointer">
        <svg-icon key="cross-icon" size="l" class="items-center" (click)="showDraggableContent()"></svg-icon>
      </div>
    </div>
  </div>
  <div class="content">
    <ng-container [ngTemplateOutlet]="video"></ng-container>
  </div>
</div>
<div
  class="container typology typology__{{ categoryId }}"
  [ngClass]="{ 'container-extension': isShown && !contentHasVideo, 'container-content': contentIsShown }">
  <div class="flex justify-between items-center">
    <div class="flex items-center">
      <svg-icon (click)="toggleAll()" key="{{ isShown ? 'less' : 'plus' }}" class="pointer" size="lg"></svg-icon>
      <div class="textOverline mx-6 h2-spacing">{{ title }}</div>
    </div>
    <div class="flex pointer">
      <svg-icon
        [ngClass]="{ 'opacity-50': isTry }"
        key="subtract"
        size="xxl"
        class="items-center"
        (click)="showDraggableContent()"></svg-icon>
    </div>
  </div>
  <div [ngClass]="seeContent && isShown ? 'content--enable' : 'hidden'" class="content mt-0">
    <div *ngIf="!isTry" [innerHTML]="contentSanitize"></div>
    <zero-info-demo *ngIf="isTry"></zero-info-demo>
  </div>

  <div *ngIf="!isTry" [ngClass]="!seeContent && contentIsShown ? 'block' : 'hidden'">
    <ng-container [ngTemplateOutlet]="video"></ng-container>
  </div>

  <span *ngIf="isShown && showButtonToogle && !contentHasVideo && !isTry" (click)="showAll()" class="pointer"
    ><strong>{{ showString | translate }}</strong>
  </span>
</div>
<ng-template #video>
  <div
    class="iframVideo typology typology__{{ categoryId }}"
    [ngClass]="{ 'flex justify-center': contentHasVideo }"
    [innerHTML]="contentSanitize"></div>
</ng-template>
